import  NetworkHandler from 'utils/network';
import config from 'config';

function getTicketStatisticsBySchedule(params) {
    const {routeId,scheduleId,page,...data} = params;
    return NetworkHandler.get(`${config.getUrl('bus_statistic')}/routes/${routeId}/schedules/${scheduleId}/tickets`,{
        params:{
            ...data,
            page: page - 1
        }
    });
}

function getTicketStatisticsByStaff(params) {
    const {routeId,staffId,page,...data} = params;
    return NetworkHandler.get(`${config.getUrl('bus_statistic')}/staffs/${staffId}/routes/${routeId}/tickets`,{
        params:{
            ...data,
            page: page - 1
        }
    });
}

export default {
    getTicketStatisticsBySchedule,
    getTicketStatisticsByStaff
};